import Vue from 'vue';
import Router from 'vue-router';

import LoginPage from '../components/Users/LoginUser/LoginPage'
import MainPage from '../components/MainPage'

Vue.use(Router);

export const router = new Router({
	mode: 'history',
	routes: [
		{ path: '/', component: MainPage },
		{ path: '/login', component: LoginPage },
		{ path: '*', redirect: '/' }
	]
});

router.beforeEach((to, from, next) => {
	// redirect to login page if not logged in and trying to access a restricted page
	const publicPages = ['/login'];

	const authRequired = !publicPages.includes(to.path);
	const loggedIn = localStorage.getItem('authData');

	const urlParams = new URLSearchParams(window.location.search);
    const impersonateUser = urlParams.get("impersonateUser");

	if (authRequired && !loggedIn && !impersonateUser) {
		return next('/login');
	}

	next();
})